/**
 * Tur 23 EK10 S074 (Yapim-B) - Bedenlerim karti + urun sayfasinda kayitli bedenin secili gelmesi. Anahtar S074 (agOz).
 * Kayit: ag:measurements (tercih_beden, alt_beden, boy_cm, kalip_tercihi) - ag-stil-sync hesaba tasir;
 * ag:beden-profil (D024 ile ayni sekil: i, boy, kilo, kalip). Riza kapatilinca hepsi silinir. Olcu vaadi yok.
 */
(function () {
  'use strict';
  if (!(window.agOz && window.agOz('S074'))) return;
  var BEDEN = ['34', '36', '38', '40', '42', '44'];
  var BOY = [[0, 154, '155 altı'], [155, 162, '155–162'], [163, 170, '163–170'], [171, 178, '171–178'], [179, 999, '178 üstü']];
  var AGS = window.AGStilSync;
  function oku(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function yaz(k, v) { if (AGS && AGS.LS) AGS.LS.set(k, v); else try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function profil() {
    var m = oku('ag:measurements') || {}, d = oku('ag:beden-profil');
    var p = { ust: m.tercih_beden || null, alt: m.alt_beden || null, boy: m.boy_cm || null, kalip: m.kalip_tercihi || null };
    if (!p.ust && d && d.i != null) p.ust = BEDEN[d.i] || null; /* D024: XS 34 ... XXL 44 */
    if (!p.kalip && d && d.kalip) p.kalip = d.kalip;
    return p;
  }

  /* ---- urun sayfasi: beden secilmemisse kayitli beden (stoktaysa) secili gelir ---- */
  function urun() {
    var pd = document.getElementById('ag-product-data'); if (!pd) return;
    var D; try { D = JSON.parse(pd.textContent); } catch (e) { return; }
    var bi = (D.optionNames || []).indexOf('Beden'); if (bi < 0 || D.selected[bi] !== null) return;
    var p = profil(); if (!p.ust && !p.alt) return;
    var alt = /etek|pantolon|şort|sort|jean/i.test((document.querySelector('.ag-product__title, h1') || {}).textContent || '');
    var b = (alt && p.alt) || p.ust || p.alt;
    var btn = document.querySelector('[data-ag-option-set="' + bi + '"][data-ag-value="' + b + '"]');
    if (!btn || btn.classList.contains('ag-size--out')) return;
    btn.click();
    btn.setAttribute('data-agb-bp-secti', '');
  }

  /* ---- Gardirobum karti ---- */
  var kart = document.querySelector('[data-agb-bp]');
  if (!kart) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', urun); else urun(); return; }
  var form = kart.querySelector('[data-agb-bp-form]'), ozet = kart.querySelector('[data-agb-bp-ozet]'), duz = kart.querySelector('[data-agb-bp-duzenle]');
  var riza = kart.querySelector('[data-agb-bp-riza]'), kaydet = kart.querySelector('[data-agb-bp-kaydet]'), durum = kart.querySelector('[data-agb-bp-durum]');
  var YENI = []; try { YENI = JSON.parse(kart.querySelector('[data-agb-bp-yeni]').textContent); } catch (e) {}

  function sec(ad, v) { var i = form.querySelector('input[name="' + ad + '"][value="' + v + '"]'); if (i) i.checked = true; }
  function doldur(p) {
    if (p.ust) sec('ust', p.ust); if (p.alt) sec('alt', p.alt); if (p.kalip) sec('kalip', p.kalip);
    form.elements.boy.value = p.boy || '';
  }
  function dolu(p) { return !!(p.ust || p.alt || p.boy || p.kalip); }
  function ozetCiz() {
    var p = profil();
    if (!dolu(p)) { ozet.textContent = 'Bedenini bir kez söyle; ürün sayfalarında hazır gelsin.'; ozet.classList.remove('agb-vh'); kart.querySelector('[data-agb-bp-dl]').hidden = true; kart.querySelector('[data-agb-bp-acik]').hidden = true; form.hidden = false; duz.hidden = true; riza.checked = false; raf(p); return; }
    var s = [];
    if (p.ust) s.push('Üst ' + p.ust); if (p.alt) s.push('Alt ' + p.alt); if (p.boy) s.push('Boy ' + p.boy + ' cm'); if (p.kalip) s.push('Kalıp ' + p.kalip.toLowerCase());
    ozet.textContent = s.join(' · ');
    /* plan uyum (mockup S074.png): 2x2 kart; ozet satiri yalniz ekran okuyucuya */
    var dl = kart.querySelector('[data-agb-bp-dl]'), d = function (k, v) { var e = dl.querySelector('[data-agb-bp-d="' + k + '"]'); e.textContent = v || '–'; };
    d('ust', p.ust); d('alt', p.alt); d('boy', p.boy ? (p.boy / 100).toFixed(2).replace('.', ',') + ' m' : ''); d('kalip', p.kalip);
    dl.hidden = false; ozet.classList.add('agb-vh'); kart.querySelector('[data-agb-bp-acik]').hidden = false;
    form.hidden = true; duz.hidden = false; riza.checked = true; kaydet.disabled = false;
    doldur(p); raf(p);
  }
  function raf(p) {
    var r = kart.querySelector('[data-agb-bp-raf]'), l = kart.querySelector('[data-agb-bp-liste]');
    var b = [p.ust, p.alt].filter(Boolean);
    var u = b.length ? YENI.filter(function (x) { return b.some(function (y) { return (x.s || []).indexOf(y) !== -1; }); }).slice(0, 6) : [];
    if (u.length < 2) { r.hidden = true; l.innerHTML = ''; return; }
    l.innerHTML = u.map(function (x) {
      var e = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var var0 = b.filter(function (y) { return (x.s || []).indexOf(y) !== -1; })[0];
      var etiket = var0 ? var0 + ' var' : 'Standart';
      return '<li><a class="agb-bp__urun" href="' + e(x.u) + '"><img src="' + e(x.i) + '" alt="" loading="lazy" width="150" height="200"><span>' + e(x.t) + '</span><span class="agb-bp__var">' + e(etiket) + '</span></a></li>';
    }).join('');
    r.hidden = false;
  }
  function sil() {
    var m = oku('ag:measurements') || {};
    delete m.tercih_beden; delete m.alt_beden; delete m.boy_cm; delete m.kalip_tercihi;
    yaz('ag:measurements', m);
    try { localStorage.removeItem('ag:beden-profil'); } catch (e) {}
    form.reset();
    document.dispatchEvent(new CustomEvent('ag:beden'));
  }

  duz.addEventListener('click', function () { form.hidden = false; duz.hidden = true; var f = form.querySelector('input'); if (f) f.focus(); });
  riza.addEventListener('change', function () {
    kaydet.disabled = !riza.checked;
    if (!riza.checked && dolu(profil())) { sil(); ozetCiz(); form.hidden = false; durum.textContent = 'Beden profilin silindi.'; }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!riza.checked) return;
    var f = form.elements, g = function (n) { var x = form.querySelector('input[name="' + n + '"]:checked'); return x ? x.value : null; };
    var boy = parseInt(f.boy.value, 10);
    if (f.boy.value && (isNaN(boy) || boy < 140 || boy > 200)) { durum.textContent = 'Boyu 140–200 cm arasında yaz.'; f.boy.focus(); return; }
    var m = oku('ag:measurements') || {};
    m.tercih_beden = g('ust') || m.tercih_beden || null; m.alt_beden = g('alt'); m.boy_cm = f.boy.value ? boy : null; m.kalip_tercihi = g('kalip');
    yaz('ag:measurements', m);
    var d = oku('ag:beden-profil') || {};
    if (m.tercih_beden && BEDEN.indexOf(m.tercih_beden) > -1) d.i = BEDEN.indexOf(m.tercih_beden);
    if (m.boy_cm) BOY.forEach(function (x) { if (m.boy_cm >= x[0] && m.boy_cm <= x[1]) d.boy = x[2]; });
    if (m.kalip_tercihi) d.kalip = m.kalip_tercihi;
    d.t = Date.now();
    if (d.i != null) try { localStorage.setItem('ag:beden-profil', JSON.stringify(d)); } catch (x) {}
    document.dispatchEvent(new CustomEvent('ag:beden'));
    ozetCiz();
    durum.textContent = 'Kaydedildi.';
    duz.focus();
  });
  ozetCiz();
})();
